export enum EventState {
  CANCELLED = 'CANCELLED',
  POSTPONED = 'POSTPONED',
  RESCHEDULED = 'RESCHEDULED',
  UPCOMING = 'UPCOMING',
}



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/client/src/model/event-state.ts